import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './components/Modal.css';
import App from './App';
import { registerServiceWorker } from './utils/push';

// data-theme is set pre-mount by the inline script in public/index.html
// (so the first paint already matches the user's preference) and kept in
// sync afterwards by context/ThemeContext.js. Nothing to do here.
//
// Old localStorage key from the pre-2026 dark mode is still cleared so
// stale values from old installs don't linger.
try { localStorage.removeItem('theme'); } catch { /* ignore */ }

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register the Service Worker once the page is loaded so push notifications
// can be delivered. Registration is idempotent and never throws.
if (typeof window !== 'undefined') {
  window.addEventListener('load', () => { registerServiceWorker(); });
}
